import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "yingyang"
const YingyangIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12.75 1.5C13.993 1.5 15 2.508 15 3.75V3.799L14.995 3.844 14.327 9.186 17.677 10.038C19.187 10.407 20.25 11.76 20.25 13.316V14.25C20.25 15.333 20.037 16.407 19.622 17.407 19.208 18.409 18.6 19.318 17.834 20.085 17.068 20.85 16.158 21.458 15.158 21.872 14.157 22.287 13.083 22.5 12 22.5S9.843 22.287 8.843 21.872C7.842 21.458 6.933 20.85 6.166 20.084 5.4 19.318 4.792 18.408 4.378 17.407 3.963 16.408 3.75 15.333 3.75 14.25V13.5C3.75 12.672 4.422 12 5.25 12H6.502L4.54 4.67C4.217 3.47 4.93 2.236 6.13 1.915 7.33 1.593 8.565 2.305 8.886 3.505L9.956 7.501 10.503 3.69C10.534 2.475 11.528 1.5 12.75 1.5M5.25 14.25C5.25 15.136 5.425 16.014 5.764 16.833 6.104 17.653 6.6 18.397 7.227 19.023 7.854 19.65 8.597 20.147 9.417 20.486 10.236 20.826 11.114 21 12 21S13.764 20.825 14.583 20.486C15.403 20.146 16.146 19.65 16.773 19.023 17.4 18.397 17.897 17.653 18.236 16.833 18.575 16.015 18.75 15.137 18.75 14.251V13.316C18.75 12.45 18.157 11.697 17.316 11.494L17.308 11.492 12.674 10.314 13.499 3.714C13.479 3.316 13.152 3 12.75 3 12.336 3 12 3.337 12 3.75V3.804L11.993 3.857 11.15 9.75H9.007L7.437 3.894C7.33 3.494 6.919 3.256 6.519 3.364 6.118 3.47 5.88 3.881 5.988 4.281L8.056 12H12C12.537 12 13.056 12.192 13.464 12.542S14.142 13.376 14.224 13.906 14.194 14.98 13.912 15.436C13.63 15.89 13.195 16.229 12.687 16.393V16.394L11.156 16.649Q11.426 16.956 11.643 17.306C12.12 18.074 12.373 18.96 12.375 19.863L10.875 19.867C10.873 19.24 10.698 18.628 10.368 18.097 10.081 17.634 9.688 17.249 9.221 16.972L7.624 17.24 7.376 15.76 12.297 14.938C12.437 14.878 12.557 14.776 12.637 14.645 12.732 14.494 12.768 14.314 12.741 14.136 12.714 13.96 12.624 13.798 12.49 13.682 12.353 13.564 12.179 13.5 12 13.5H5.25z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default YingyangIcon
